import { BASE_URL } from '../../App'
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row, Col, Card } from 'antd';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import LOGO from '../image/cri_logo.jpg';
import CustomTextField from "../Reusable/Numerictext";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormGroup, Stack, Backdrop, createTheme, ThemeProvider, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem, ListItemText, Checkbox, Grid, FormControlLabel } from '@mui/material';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { blue } from '@mui/material/colors';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
const styles = {
    tableContainer: {
        maxHeight: '400px',
        overflowY: 'auto',
    },
    headerCell: {
        fontWeight: 'bold',
        backgroundColor: blue[500], // Using MUI blue primary color
        color: '#ffffff',
        textAlign: 'center',
        fontSize: '1rem',
    },
    bodyCell: {
        padding: '12px 16px',
        textAlign: 'center',
        fontSize: '0.875rem',
    },
    debitCreditCell: {
        padding: '12px 16px',
        textAlign: 'right',
        fontSize: '0.875rem',
    },
    tableRow: (index) => ({
        backgroundColor: index % 2 === 0 ? '#f1f1f1' : '#ffffff',
    }),
};

export default function PriceList() {


    const [subdealerlist, setsubdealerlist] = useState([]);
    const [categories, setCategories] = useState(null);
    const [region, setRegion] = useState([]);
    const [ItemList, setItemList] = useState([]);
    const [ItemList1, setItemList1] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    // const [selecteddealer, setselecteddealer] = useState(null);
    const [SelectedRegionCode, setSelectedRegionCode] = useState(null);
    const [SelectedSector, setSelectedSector] = useState(null);
    const [showCard, setShowCard] = useState(false);
    const [open, setOpen] = React.useState(false);

    const [selectedItems, setSelectedItems] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [priceListData, setPriceListData] = useState(null);
    const [address, setAddress] = useState(null);
    const [financialyearcount, setFinancialYearCount] = useState(0);
    const [selectedDealer, setSelectedDealer] = useState(null);

    //const [selectedGroup, setselectedGroup] = useState('');

    const [selecteditem, setselectedItem] = useState(null);

    const BRANCH_CODE = localStorage.getItem('BRANCH_CODE');
    const token = localStorage.getItem('Token');
    const headers = { Authorization: `Bearer ${token}` };
    const [selectedValue, setSelectedValue] = useState({});

    const [selectedDate, setSelectedDate] = useState(dayjs());
    const login_id = localStorage.getItem("LOGIN_ID");
    const [tableData, setTableData] = useState([]);
    const [period, setperiod] = useState(null);
    const [closing, setclosing] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState('');
    const [selectedname, setSelectedname] = useState('');

    const [selectedItem, setSelectedItem] = useState(null);
    // const login_id = "s4nQJJzkLN0X1YSjek9P86wH+83VnZxnTdzOohjEBN8psBDaMVVGjVVzZVYsz9UdoYDsvZtKrGFK85UoDHPv8A==";
    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
    };

    const handlGroupChange = (event, newValue) => {
        console.log('test', newValue)
        setSelectedDealer(newValue.Value);
    };

    useEffect(() => {
        // Sundealerlist();
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(BASE_URL + '/getdealercode', { login_id: login_id });
                // const response = await axios.post(BASE_URL + '/getsubdelaerlist', { dealer_code: '5103176' });
                if (response.status === 200) {
                    setsubdealerlist(response.data.DEALER_CODE);
                    const dealerData = response.data.DEALER_CODE;

                    if (dealerData.length > 0) {
                        setSelectedGroup({
                            values: {
                                DEALER_CODE: String(dealerData[0].DEALER_CODE),
                                DEALERNAME: String(dealerData[0].DEALERNAME),
                            }
                        });
                    }

                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        // Fetch financial year count
        const fetchFinancialYearCount = async () => {
            try {
                const response = await axios.post(BASE_URL + '/financialyearcount', { login_id: login_id });
                if (response.status === 200) {
                    setFinancialYearCount(response.data.financialyearcount);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            } catch (error) {

            }
        };
        fetchFinancialYearCount();
    }, [login_id]);


    useEffect(() => {
        // Generate options once financialyearcount is fetched
        if (financialyearcount > 0) {
            generateFinancialYearOptions();
        }
    }, [financialyearcount]);



    // const handleItemChange = (event ,newValue) => {
    //     setselectedItem(newValue.Value);
    //     // Handle onChange logic here if needed
    // };
    const generateFinancialYearOptions = () => {
        const options = [];
        const currentYear = new Date().getFullYear();

        for (let i = 0; i < financialyearcount; i++) {
            const startYear = currentYear - i;
            const endYear = startYear + 1;
            const financialYearName = `${startYear}-${endYear}`;
            options.push({ Value: financialYearName, Label: financialYearName });
        }
        return options;
    };


    const [subgrouppcode, setsubgrouppcode] = useState([]);


    const handleGroupChange = (newValue) => {
        setSelectedGroup(newValue);
    };

    const handleItemChange = (newValue) => {
        setSelectedItem(newValue);
    };

    const getOptionLabel = (option) => {
        return option ? option.Value : '';
    };





    const Subdealer_List = subdealerlist ? subdealerlist.map((type) => ({
        Value: type.DEALER_CODE,
        Label: type.DEALER_CODE + '  - ' + type.DEALERNAME,
    })) : [];




    const [rptcode, setrptcode] = useState([]);



    const [selectedDealername, setSelectedDealername] = useState('');



    //handlitemChange

    const [selecteditemdesc, setselecteditemdesc] = useState('');

    const handlePriceList = () => {
        setOpen(true);
        const data = { dealer_code: selectedGroup, financialyear: selectedItem };
        axios.post(BASE_URL + '/getaccounttransaction', data)
            .then(response => {
                if (response.status === 200) {
                    // Assuming response.data.getaccounttransaction is an array of statements
                    setTableData(response.data.getaccounttransaction);
                    setperiod(response.data.Period)
                    setclosing(response.data.closing)
                    setShowCard(true); // Show any relevant component if needed
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            })
            .finally(() => {
                setOpen(false); // Close loading indicator regardless of success or failure
            });
    };

    // const handleExportExcelClick = () => {

    //     const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"; // Define the Excel type
    //     const reportData = [
    //         ["Dealer Accounts Transactions Report"],
    //         [`Date: ${new Date().toLocaleDateString('en-US', {
    //             month: 'long', day: 'numeric', year: 'numeric'
    //         })}`],
    //         [`Dealer: ${selectedname}`],
    //         [], 
    //         ["Document Type", "Document Number", "Document Date", "Posting Date", "Reference No", "Narration", "Debit", "Credit"],
    //     ];
    

    //     tableData.forEach(row => {
    //         reportData.push([
    //             row.DOCUMENT_TYPE,
    //             row.DOCUMENT_NUMBER,
    //             row.DOCUMENT_DATE,
    //             row.POSTING_DATE,
    //             row.REFERENCE,
    //             row.DESCRIPTION,
    //             formatToINR(row.DEBIT),
    //             formatToINR(row.CREDIT)
    //         ]);
    //     });
    

    //     const ws = XLSX.utils.aoa_to_sheet(reportData);
        
 
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Transactions");
    
 
    //     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    //     const data = new Blob([excelBuffer], { type: EXCEL_TYPE });
    //     saveAs(data, "Dealer_Transactions_Report.xlsx");
    // };

    // const handleExportExcelClick = () => {
    //     const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"; // Define the Excel type
    
    //     const reportData = [
    //         ["Dealer Accounts Transactions Report"],
    //         [`Date: ${new Date().toLocaleDateString('en-US', {
    //             month: 'long', day: 'numeric', year: 'numeric'
    //         })}`],
    //         [`Dealer: ${selectedname}`],
    //         [], // Empty row for spacing
    //         ["Document Type", "Document Number", "Document Date", "Posting Date", "Reference No", "Narration", "Debit", "Credit"], // Header row
    //     ];
    
    //     // Add table data
    //     tableData.forEach(row => {
    //         reportData.push([
    //             row.DOCUMENT_TYPE,
    //             row.DOCUMENT_NUMBER,
    //             row.DOCUMENT_DATE,
    //             row.POSTING_DATE,
    //             row.REFERENCE,
    //             row.DESCRIPTION,
    //             formatToINR(row.DEBIT),
    //             formatToINR(row.CREDIT)
    //         ]);
    //     });
    
    //     // Create a worksheet
    //     const ws = XLSX.utils.aoa_to_sheet(reportData);
    
    //     // Set the widths for columns (adjust as needed)
    //     ws["!cols"] = [
    //         { wpx: 200 }, // Document Type
    //         { wpx: 150 }, // Document Number
    //         { wpx: 150 }, // Document Date
    //         { wpx: 150 }, // Posting Date
    //         { wpx: 150 }, // Reference No
    //         { wpx: 250 }, // Narration
    //         { wpx: 100 }, // Debit
    //         { wpx: 100 }, // Credit
    //     ];
    
    //     // Apply styles for the header row (5th row)
    //     const headerRow = 4; // 0-indexed row number for headers
    //     const headerCellStyle = {
    //         fill: {
    //             fgColor: { rgb: "FFCCCCCC" } // Light grey background
    //         },
    //         font: {
    //             bold: true,
    //             color: { rgb: "FF000000" } // Black font color
    //         }
    //     };
    
    //     // Apply style to each cell in the header row
    //     for (let col = 0; col < reportData[headerRow].length; col++) {
    //         const cellRef = XLSX.utils.encode_cell({ r: headerRow, c: col });
    //         if (!ws[cellRef]) ws[cellRef] = {}; // Create cell if it doesn't exist
    //         ws[cellRef].s = headerCellStyle; // Apply style to header cell
    //     }
    
    //     // Enable filtering for the header row (5th row)
    //     ws['!autofilter'] = { ref: `A${headerRow + 1}:H${reportData.length}` }; // Set filter on the range of the header row and data
    
    //     const headerBackgroundStyle = {
    //         fill: {
    //             fgColor: { rgb: "FFCCFF00" } // Bright yellow background
    //         }
    //     };

    //     for (let col = 0; col < reportData[headerRow].length; col++) {
    //         const cellRef = XLSX.utils.encode_cell({ r: headerRow, c: col });
    //         if (!ws[cellRef]) ws[cellRef] = {}; // Create cell if it doesn't exist
    //         ws[cellRef].s = { ...ws[cellRef].s, ...headerBackgroundStyle }; // Merge styles
    //     }
    //     // Create a new workbook and add the worksheet to it
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Transactions");
    
    //     // Export the Excel file
    //     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    //     const data = new Blob([excelBuffer], { type: EXCEL_TYPE });
    //     saveAs(data, "Dealer_Transactions_Report.xlsx");
    // };

    const handleExportExcelClick = () => {
        const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    
        const reportData = [
            ["Dealer Accounts Transactions Report"],
            [`Date: ${new Date().toLocaleDateString('en-US', {
                month: 'long', day: 'numeric', year: 'numeric'
            })}`],
            [`Dealer: ${selectedname}`],
            [], // Empty row for spacing
            ["Document Type", "Document Number", "Document Date", "Posting Date", "Reference No", "Narration", "Debit", "Credit"], // Header row
        ];
    
        // Add table data
        tableData.forEach(row => {
            reportData.push([
                row.DOCUMENT_TYPE,
                row.DOCUMENT_NUMBER,
                row.DOCUMENT_DATE,
                row.POSTING_DATE,
                row.REFERENCE,
                row.DESCRIPTION,
                formatToINR(row.DEBIT),
                formatToINR(row.CREDIT)
            ]);
        });
    
        // Create a worksheet
        const ws = XLSX.utils.aoa_to_sheet(reportData);
    
        // Set the widths for columns (adjust as needed)
        ws["!cols"] = [
            { wpx: 200 }, // Document Type
            { wpx: 150 }, // Document Number
            { wpx: 150 }, // Document Date
            { wpx: 150 }, // Posting Date
            { wpx: 150 }, // Reference No
            { wpx: 250 }, // Narration
            { wpx: 100 }, // Debit
            { wpx: 100 }, // Credit
        ];
    
        // Apply styles for the header row (5th row)
        const headerRow = 4; // 0-indexed row number for headers
        const headerCellStyle = {
            fill: {
                fgColor: { rgb: "FFCCFF00" } // Bright yellow background
            },
            font: {
                bold: true,
                color: { rgb: "FF000000" } // Black font color
            }
        };
    
        // Apply style to each cell in the header row
        for (let col = 0; col < reportData[headerRow].length; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: headerRow, c: col });
            if (!ws[cellRef]) ws[cellRef] = {}; // Create cell if it doesn't exist
            ws[cellRef].s = headerCellStyle; // Apply style to header cell
        }
    
        // Enable filtering for the header row (5th row)
        ws['!autofilter'] = { ref: `A${headerRow + 1}:H${reportData.length}` }; // Set filter on the range of the header row and data
    
        // Set background color for the filter row (same as header row)
        for (let col = 0; col < reportData[headerRow].length; col++) {
            const filterCellRef = XLSX.utils.encode_cell({ r: headerRow, c: col });
            if (!ws[filterCellRef]) ws[filterCellRef] = {}; // Create cell if it doesn't exist
            ws[filterCellRef].s = headerCellStyle; // Apply the same style to filter row
        }
    
        // Create a new workbook and add the worksheet to it
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Transactions");
    
        // Export the Excel file
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: EXCEL_TYPE });
        saveAs(data, "Dealer_Transactions_Report.xlsx");
    };
    
    
    
    
    


    // const handleExportExcelClick = () => {
    //     if (tableData.length === 0) {
    //         Swal.fire({
    //             icon: "info",
    //             text: 'No Data Available For export!'
    //         });
    //         return;
    //     }
    //     Swal.fire({
    //         title: 'Are you sure?',
    //         text: 'Do you want to download the Excel file?',
    //         icon: 'question',
    //         showCancelButton: true,
    //         confirmButtonText: 'Yes, download it!',
    //         cancelButtonText: 'No, cancel!',
    //         reverseButtons: true
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             setOpen(true);

    //             const ExcelJS = require('exceljs');
    //             const workbook = new ExcelJS.Workbook();
    //             const worksheet = workbook.addWorksheet('Sheet1');
    //             worksheet.addRow(['Sample Text: This is a sample report']).font = { bold: true };
    //             worksheet.addRow(['Dealer Accounts Transactions Report']).font = { bold: true };
    //             const dealerName = selectedGroup ? selectedGroup : 'Unknown Dealer';
    //             const currentDate = new Date();
    //             const options = { month: 'long', day: 'numeric', year: 'numeric' };
    //             const formattedDate = currentDate.toLocaleDateString('en-US', options).replace(',', '').replace(/\//g, ' - ');
    //             worksheet.addRow([`Date: ${formattedDate}`]).font = { bold: true }; 
    //             worksheet.addRow([`Dealer Name: ${dealerName}`]).font = { bold: true }; 
    //             worksheet.addRow([]);
    //             worksheet.columns = Object.keys(tableData[0]).map(key => ({ header: key, key }));
    //             const headerRow = worksheet.addRow(Object.keys(tableData[0])); 
    //             headerRow.eachCell((cell) => {
    //                 cell.fill = {
    //                     type: 'pattern',
    //                     pattern: 'solid',
    //                     fgColor: { argb: '1f7f9c' }
    //                 };
    //                 cell.font = { bold: true }; 
    //             });


    //             tableData.forEach(data => worksheet.addRow(data));

    //             worksheet.columns.forEach(column => {
    //                 let maxLength = 0;
    //                 column.eachCell({ includeEmpty: true }, (cell) => {
    //                     const cellLength = cell.value ? cell.value.toString().length : 0;
    //                     if (cellLength > maxLength) {
    //                         maxLength = cellLength;
    //                     }
    //                 });
    //                 column.width = maxLength < 10 ? 10 : maxLength + 2; 
    //             });

    //             worksheet.autoFilter = {
    //                 from: `A6`, 
    //                 to: `I6` 
    //             };

    //             setTimeout(() => {
    //                 workbook.xlsx.writeBuffer().then((buffer) => {
    //                     const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //                     const link = document.createElement('a');
    //                     link.href = window.URL.createObjectURL(blob);
    //                     link.download = `Accountstransaction-${dealerName}-${selectedItem}.xlsx`;
    //                     link.click();
    //                     setOpen(false);
    //                 });
    //             }, 1000);
    //         }
    //     });
    // };


    const formatToINR = (value) => {
        // Ensure value is a string and handle possible null or undefined
        const stringValue = String(value || '');

        // Remove commas if present and convert to number
        const number = Number(stringValue.replace(/,/g, ''));

        // Format the number to INR and return
        return number.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }).replace('₹', '');
    };

    // useEffect(() => {
        // if (Subdealer_List.length > 0) {
           


            // setSelectedGroup(Subdealer_List[0].Value);
            // setSelectedname(Subdealer_List[0].Label);
        // }

        // console.log('Subdealer_List', Subdealer_List[0]);
    // }, [Subdealer_List]);

    return (
        <>
            <br />
            <div className="container mt-5" style={{ justifyContent: 'center' }}>

                <br />
                <div className='row'>
                    <div className='col-md-6'>
                        <SelectSearch
                            label="Dealer Code"
                            required={true}
                            options={Subdealer_List}
                            getOptionLabel={getOptionLabel}
                            value={selectedGroup}
                            onChange={handleGroupChange}
                        />

                    </div>

                    <div className='col-md-6'>
                        {/* <label >E-Code</label> */}
                        <SelectSearch
                            label="Financial Year"
                            required={true}
                            options={generateFinancialYearOptions()}
                            getOptionLabel={getOptionLabel}
                            value={selectedItem}
                            onChange={handleItemChange}
                        />
                    </div>
                </div>
                <br />
                <div className='row'>
                    <Button size="small" fullWidth variant="contained" onClick={handlePriceList} ><b>View</b></Button>
                </div>


                <hr />
                {tableData.length > 0 && (
                    <div>

                        <Card style={{
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            borderRadius: '10px',
                        }}>


                            <div className='row'>
                                <div className='col-md-2'>
                                    <Button size="small" fullWidth variant="contained" onClick={() => handleExportExcelClick()} endIcon={<DescriptionTwoToneIcon />}  ><b>Download Excel</b></Button>
                                </div>

                                <div className='col-md-6'>
                                    <label htmlFor="Period" style={{ fontWeight: 'bold' }}>{period}</label>

                                </div>


                                <div className='col-md-2'>


                                </div>


                            </div>

                        </Card>

                    </div>
                )}
                {tableData.length > 0 && (
                    <>

                        <div id='Content' style={{
                            visibility: 'hidden'
                        }} >
                            <label>Dealer Accounts Transactions Report</label><br />
                            <label>Date : {new Date().toLocaleDateString('en-US', {
                                month: 'long', day: 'numeric', year: 'numeric'
                            })}</label><br />
                            <label>Dealer  : {selectedname}</label><br />

                        </div>
                    </>
                )}
                {tableData.length > 0 && (




                    <TableContainer component={Paper} style={styles.tableContainer}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={styles.headerCell}> Document Type</TableCell>
                                    <TableCell style={styles.headerCell}> Document Number</TableCell>
                                    <TableCell style={styles.headerCell}>Document Date</TableCell>
                                    <TableCell style={styles.headerCell}>  Posting Date </TableCell>
                                    <TableCell style={styles.headerCell}>Reference No</TableCell>

                                    <TableCell style={styles.headerCell}>Narration</TableCell>
                                    <TableCell style={styles.headerCell}>Debit</TableCell>
                                    <TableCell style={styles.headerCell}>Credit</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.map((row, index) => (
                                    <TableRow key={index} style={styles.tableRow(index)}>
                                        <TableCell style={styles.bodyCell}>{row.DOCUMENT_TYPE}</TableCell>
                                        <TableCell style={styles.bodyCell}>{row.DOCUMENT_NUMBER}</TableCell>
                                        <TableCell style={styles.bodyCell}>{row.DOCUMENT_DATE}</TableCell>
                                        <TableCell style={styles.bodyCell}>{row.POSTING_DATE}</TableCell>
                                        <TableCell style={styles.bodyCell}>{row.REFERENCE}</TableCell>

                                        <TableCell style={styles.bodyCell}>{row.DESCRIPTION}</TableCell>
                                        <TableCell style={styles.debitCreditCell}>{formatToINR(row.DEBIT)}</TableCell>
                                        <TableCell style={styles.debitCreditCell}>{formatToINR(row.CREDIT)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                <br />
                {tableData.length > 0 && (
                    <div>

                        <Card style={{
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            borderRadius: '10px',
                        }}>

                            <div className='row'>
                                <div className='col-md-2'>

                                </div>


                                <div className='col-md-6'>
                                    <label htmlFor="closing" style={{ fontWeight: 'bold' }}>{closing}</label>

                                </div>


                                <div className='col-md-2'>


                                </div>


                            </div>

                        </Card>

                    </div>
                )}

                <br />

                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>


            </div>
        </>
    );
};


